/**
 * Presentational theme map (Req 2.7, 2.8).
 *
 * `theme` is a purely presentational hint forwarded verbatim by the agent.
 * It affects STYLING ONLY (accent color, label, optional icon) and never
 * which renderer `kind` selects nor the layout produced by that renderer.
 * Unknown or absent themes resolve to a neutral default.
 */

export interface ThemeStyle {
  /** Accent color (hex) used for borders/labels. */
  accent: string;
  /** Human-readable label shown as a small badge. */
  label: string;
  /** Optional icon glyph shown next to the label. */
  icon?: string;
}

const NEUTRAL: ThemeStyle = {
  accent: '#64748b', // slate-500
  label: 'Content',
};

const THEMES: Record<string, ThemeStyle> = {
  jira: { accent: '#2563eb', label: 'Jira', icon: '🧩' }, // blue-600
  confluence: { accent: '#3b82f6', label: 'Confluence', icon: '📘' }, // blue-500
};

/**
 * Resolve a theme string to its presentational style. Unknown/absent themes
 * return the neutral default so layout is unchanged (Req 2.8).
 */
export function getTheme(theme?: string): ThemeStyle {
  if (!theme) return NEUTRAL;
  return THEMES[theme.toLowerCase()] ?? NEUTRAL;
}
